import { useContext, useEffect, useRef, useState } from "react";
import { UserAuthContext } from "../../Contexts/UserAuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import PageHeading from "../../Components/PageHeading/PageHeading";
import moment from "moment";
import moneyExchangeIcon from "../../Assets/Images/transaction-data.png";
import "./BusinessPlanAi.css";

import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export default function GeneratedBusinessPlan() {
    const { AIuser } = useContext(UserAuthContext);
    const location = useLocation();
    const navigate = useNavigate();

    const data = location.state;

    const [numPages, setNumPages] = useState(null);
    const [pageWidth, setPageWidth] = useState(800);

    const pdfContainerRef = useRef(null);

    const creditToLocalString = AIuser?.credits
        ? parseInt(Math.floor(AIuser?.credits)).toLocaleString()
        : "0";

    useEffect(() => {
        window.scrollTo(0, 0);

        if (!data) {
            navigate("/usage");
        }
    }, [data, navigate]);

    useEffect(() => {
        const updateWidth = () => {
            if (pdfContainerRef.current) {
                const width = pdfContainerRef.current.offsetWidth;

                if (window.innerWidth < 768) {
                    setPageWidth(width - 20);
                } else {
                    setPageWidth(Math.min(width - 20, 800));
                }
            }
        };

        updateWidth();
        window.addEventListener("resize", updateWidth);

        return () => {
            window.removeEventListener("resize", updateWidth);
        };
    }, []);

    if (!data) {
        return (
            <div>
                <PageHeading
                    title={"GENERATED Business Plan AI"}
                    description={"View your generated Business Plan AI"}
                />

                <div
                    className="container text-center"
                    style={{
                        minHeight: "50vh",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <h5 className="text-white">No data found</h5>
                </div>
            </div>
        );
    }

    const {
        aiType,
        transactionId,
        totalCreditsUsed,
        dateTime,
        pdfUrl,
        remarks,
    } = data;

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    };

    const handleDownload = async () => {
        try {
            const response = await fetch(pdfUrl);
            const blob = await response.blob();

            const url = window.URL.createObjectURL(blob);

            const fileName = pdfUrl.split("/").pop();

            const link = document.createElement("a");
            link.href = url;
            link.download = fileName;

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("PDF download failed:", error);
        }
    };

    return (
        <div className="container">
            <PageHeading
                title={"GENERATED Business Plan AI"}
                description={"View your generated Business Plans"}
            />

            <div className="container companion-ai-main">
                <div
                    style={{
                        maxWidth: "872px",
                        paddingInline: "12px",
                        marginInline: "auto",
                    }}
                >
                    {/* Credits */}
                    <div className="d-flex align-items-center justify-content-center centralize-credits-btn-sm mt-2 mb-4">
                        <button className="credits-button">
                            CREDITS : {creditToLocalString}
                        </button>

                        <button
                            className="buy-credits-button"
                            onClick={() => navigate("/purchase")}
                        >
                            BUY CREDITS
                        </button>

                        <button
                            onClick={() => navigate("/usage")}
                            className="money-exchange-button"
                        >
                            <img src={moneyExchangeIcon} alt="exchange" />
                        </button>
                    </div>

                    {/* Success Card */}
                    <div className="text-center mb-4">
                        <div
                            style={{
                                background: "#011C34",
                                border: "2px solid #FFF",
                                borderRadius: "16px",
                                padding: "40px 30px",
                            }}
                        >
                            <div
                                style={{
                                    width: "60px",
                                    height: "60px",
                                    background:
                                        "linear-gradient(135deg, #00ff88, #00cc70)",
                                    borderRadius: "50%",
                                    margin: "0 auto 25px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    fontSize: "30px",
                                }}
                            >
                                ✓
                            </div>

                            <h4
                                className="text-white mb-3"
                                style={{ fontWeight: "600" }}
                            >
                                {remarks}
                            </h4>

                            <p
                                className="text-white mb-4"
                                style={{
                                    fontSize: "14px",
                                    opacity: 0.8,
                                    maxWidth: "600px",
                                    margin: "0 auto 20px",
                                }}
                            >
                                Business Plan generated successfully
                            </p>

                            <div
                                style={{
                                    background:
                                        "rgba(0, 255, 136, 0.1)",
                                    border:
                                        "2px solid rgba(0, 255, 136, 0.3)",
                                    borderRadius: "10px",
                                    padding: "10px 20px",
                                    display: "inline-block",
                                }}
                            >
                                <span
                                    style={{
                                        color: "#00ff88",
                                        fontWeight: "bold",
                                        fontSize: "13px",
                                        textTransform: "uppercase",
                                        letterSpacing: "1px",
                                    }}
                                >
                                    COMPLETED
                                </span>
                            </div>
                        </div>
                    </div>

                    {/* Transaction Info */}
                    <div className="mb-3">
                        <div
                            style={{
                                background: "#011C34",
                                border: "2px solid #FFF",
                                borderRadius: "12px",
                                padding: "15px",
                            }}
                        >
                            <div className="row">
                                <div className="col-md-6 mb-2">
                                    <p className="text-white mb-1">
                                        <strong>Transaction ID:</strong>{" "}
                                        {transactionId}
                                    </p>
                                </div>

                                <div className="col-md-6 mb-2">
                                    <p className="text-white mb-1">
                                        <strong>Credits Used:</strong>{" "}
                                        {totalCreditsUsed}
                                    </p>
                                </div>

                                <div className="col-md-6 mb-2">
                                    <p className="text-white mb-1">
                                        <strong>Date:</strong>{" "}
                                        {moment(dateTime).format(
                                            "DD-MM-YYYY HH:mm:ss"
                                        )}
                                    </p>
                                </div>

                                <div className="col-md-6 mb-2">
                                    <p className="text-white mb-0">
                                        <strong>Topic:</strong> {remarks}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* PDF */}
                    {pdfUrl && (
                        <div className="mb-3">
                            <div
                                style={{
                                    background: "#011C34",
                                    border: "2px solid #FFF",
                                    borderRadius: "12px",
                                    padding: "15px",
                                }}
                            >
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                    <h6 className="text-white mb-0">
                                        <strong>
                                            Generated Business Plan
                                        </strong>
                                    </h6>

                                    <button
                                        className="btn btn-primary btn-sm"
                                        onClick={handleDownload}
                                    >
                                        Download PDF
                                    </button>
                                </div>

                                <div ref={pdfContainerRef}>
                                    <Document
                                        file={pdfUrl}
                                        onLoadSuccess={
                                            onDocumentLoadSuccess
                                        }
                                    >
                                        {numPages &&
                                            Array.from(
                                                { length: numPages },
                                                (_, index) => (
                                                    <Page
                                                        key={index}
                                                        pageNumber={
                                                            index + 1
                                                        }
                                                        width={pageWidth}
                                                        renderTextLayer
                                                        renderAnnotationLayer
                                                    />
                                                )
                                            )}
                                    </Document>
                                </div>
                            </div>

                            <p className="text-warning text-center pt-4 mb-0">
                                Please download the PDF within 30 days, as it
                                may be deleted after that time.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}